import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check, RotateCw, ChevronDown, Search, Send, Bot, Zap, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { WHATSAPP_URL } from '../lib/contact';

const ChatMock = () => (
  <div className="relative w-full max-w-[560px] mx-auto">
    <div className="absolute -inset-6 bg-gradient-to-br from-[#FF5B24]/20 via-transparent to-indigo-300/25 rounded-[36px] blur-2xl -z-10" />
    <div className="bg-white rounded-2xl shadow-[0_30px_80px_-20px_rgba(10,14,39,0.35)] border border-slate-100 overflow-hidden">
      {/* Top bar */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-slate-50/60">
        <div className="flex gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-[#ff5f57]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#febc2e]" />
          <span className="w-2.5 h-2.5 rounded-full bg-[#28c840]" />
        </div>
        <div className="ml-3 text-xs text-slate-500 font-medium">CoreDesk · Conversas</div>
        <div className="ml-auto flex items-center gap-2">
          <RotateCw size={13} className="text-slate-400" />
          <ChevronDown size={13} className="text-slate-400" />
        </div>
      </div>

      <div className="grid grid-cols-[220px_1fr]">
        {/* Sidebar list */}
        <div className="border-r border-slate-100 bg-white">
          <div className="px-3 py-3">
            <div className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider">Conversas</div>
            <div className="mt-2 space-y-0.5">
              {[
                ['Todas', '674'],
                ['Suas', '9'],
                ['Não respondidas', '0'],
                ['Bot', '618'],
              ].map(([k, v]) => (
                <div key={k} className="flex items-center justify-between text-xs py-1.5 px-2 rounded-md hover:bg-slate-50">
                  <span className="text-slate-600">{k}</span>
                  <span className="text-slate-400 font-medium">{v}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="px-3 pb-3 border-t border-slate-100 pt-3">
            <div className="flex items-center gap-1.5 rounded-md bg-slate-50 px-2 py-1.5">
              <Search size={12} className="text-slate-400" />
              <span className="text-[11px] text-slate-400">Buscar...</span>
            </div>
            <div className="mt-3 space-y-2">
              {[
                { n: 'Juliana K.', m: 'Oi! Que bom que você...', t: '45m', c: '#25D366' },
                { n: 'Marco Silva', m: 'Fico feliz em ouvir...', t: '1h', c: '#4267B2' },
                { n: 'Lucia Gomes', m: 'Oi! Como estão...', t: '20m', c: '#E1306C' },
                { n: 'Patrícia L.', m: 'Que bom receber...', t: '35m', c: '#25D366' },
              ].map((c) => (
                <div key={c.n} className="flex items-start gap-2 rounded-lg p-1.5 hover:bg-slate-50 cursor-pointer">
                  <div className="relative">
                    <div className="w-7 h-7 rounded-full bg-gradient-to-br from-slate-200 to-slate-300 flex items-center justify-center text-[10px] font-bold text-slate-600">
                      {c.n.charAt(0)}
                    </div>
                    <span
                      className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-white"
                      style={{ background: c.c }}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-center">
                      <span className="text-[11px] font-semibold text-[#0a0e27] truncate">{c.n}</span>
                      <span className="text-[9px] text-slate-400">{c.t}</span>
                    </div>
                    <div className="text-[10px] text-slate-500 truncate">{c.m}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Chat */}
        <div className="flex flex-col bg-[#F7F8FC] min-h-[320px]">
          <div className="px-4 py-2.5 bg-white border-b border-slate-100 flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-[#FF5B24] text-white flex items-center justify-center text-[10px] font-bold">JK</div>
            <div>
              <div className="text-xs font-semibold text-[#0a0e27]">Juliana Karla</div>
              <div className="text-[10px] text-emerald-600 font-medium">online</div>
            </div>
          </div>
          <div className="flex-1 p-3 space-y-2 overflow-hidden">
            <div className="flex justify-start">
              <div className="bg-white rounded-2xl rounded-tl-sm px-3 py-2 text-xs text-slate-700 max-w-[75%] shadow-sm">
                Olá! Gostaria de mais informações sobre o plano Business.
              </div>
            </div>
            <div className="flex items-center gap-1.5 text-[10px] text-slate-400 pl-2">
              <Bot size={11} className="text-[#FF5B24]" /> CoreAI está respondendo...
            </div>
            <div className="flex justify-end">
              <div className="bg-[#0a0e27] text-white rounded-2xl rounded-tr-sm px-3 py-2 text-xs max-w-[75%]">
                Olá Juliana! O Business inclui canais ilimitados, CoreAI Copiloto e automações. Quer que eu agende uma demo?
              </div>
            </div>
            <div className="flex justify-start">
              <div className="bg-white rounded-2xl rounded-tl-sm px-3 py-2 text-xs text-slate-700 max-w-[75%] shadow-sm">
                Sim, pode ser amanhã às 15h?
              </div>
            </div>
          </div>
          <div className="px-3 pb-3">
            <div className="flex items-center gap-2 bg-white rounded-full border border-slate-200 px-3 py-2">
              <Sparkles size={13} className="text-[#FF5B24]" />
              <span className="text-[11px] text-slate-400 flex-1">Digite / para respostas prontas</span>
              <div className="w-6 h-6 rounded-full bg-[#FF5B24] flex items-center justify-center">
                <Send size={11} className="text-white" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Floating stat cards */}
    <div className="hidden md:flex absolute -left-8 top-16 bg-white shadow-xl rounded-xl px-3 py-2 items-center gap-2 border border-slate-100">
      <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
        <Check size={16} className="text-emerald-600" />
      </div>
      <div>
        <div className="text-[10px] text-slate-400">Tempo de resposta</div>
        <div className="text-xs font-bold text-[#0a0e27]">-72%</div>
      </div>
    </div>
    <div className="hidden md:flex absolute -right-8 bottom-16 bg-white shadow-xl rounded-xl px-3 py-2 items-center gap-2 border border-slate-100">
      <div className="w-8 h-8 rounded-lg bg-[#FFF1EA] flex items-center justify-center">
        <Zap size={16} className="text-[#FF5B24]" />
      </div>
      <div>
        <div className="text-[10px] text-slate-400">Automações ativas</div>
        <div className="text-xs font-bold text-[#0a0e27]">128</div>
      </div>
    </div>
  </div>
);

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#FAF6F2] via-white to-white">
      <div className="blob w-[520px] h-[520px] bg-[#FF5B24]/25 -top-20 -left-24" />
      <div className="blob w-[420px] h-[420px] bg-indigo-300/25 top-24 right-0" />
      <div className="bg-grid absolute inset-0 opacity-40" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-20">
        <div className="grid lg:grid-cols-[1.05fr_1fr] gap-10 items-center">
          <div className="fade-up">
            <div className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-[#FF5B24]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF5B24]" />
              Plataforma de atendimento com IA
            </div>
            <h1 className="mt-4 text-[42px] leading-[1.05] md:text-6xl lg:text-[64px] font-extrabold text-[#0a0e27]">
              Venda e atenda em escala, com <span className="text-[#FF5B24]">agentes de IA</span> que nunca param
            </h1>
            <p className="mt-6 text-lg text-slate-600 max-w-xl leading-relaxed">
              Do primeiro contato ao helpdesk: gerencie conversas, qualifique leads e resolva chamados com o <b>CoreAI</b>. Tudo na mesma plataforma.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Button asChild className="btn-coral rounded-full h-12 px-6 text-sm font-semibold gap-1.5">
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                  Falar no WhatsApp
                  <ArrowUpRight size={17} />
                </a>
              </Button>
              <Button asChild variant="outline" className="rounded-full h-12 px-6 text-sm font-semibold border-[#0a0e27]/15 text-[#0a0e27] hover:bg-[#0a0e27] hover:text-white">
                <Link to="/contato">Agendar demonstração</Link>
              </Button>
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-2">
              <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1.5 shadow-sm">
                <span className="w-6 h-6 rounded-full bg-[#25D366] flex items-center justify-center text-white text-[10px] font-bold">W</span>
                <span className="text-xs font-medium text-slate-700">Multiatendimento no WhatsApp</span>
              </div>
              <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1.5 shadow-sm">
                <span className="w-6 h-6 rounded-full bg-emerald-500 flex items-center justify-center text-white text-[10px] font-bold">✓</span>
                <span className="text-xs font-medium text-slate-700">100% LGPD</span>
              </div>
              <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1.5 shadow-sm">
                <span className="w-6 h-6 rounded-full bg-[#FF5B24] flex items-center justify-center text-white text-[10px] font-bold">14</span>
                <span className="text-xs font-medium text-slate-700">dias grátis para testar</span>
              </div>
            </div>
          </div>
          <div className="fade-up">
            <ChatMock />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
